import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadButton from '/src/components/download-button';

const DYNAMIC_WORD_KEYS = [
	'recording',
	'safety',
	'roadside',
	'driving',
];

const DYNAMIC_LETTER_TIMER = 175;
const EOW_BUFFER = 8;

const Splash = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.splash' });

	// const dynamicText = useRef();

	// useEffect(() => {
	// 	let i = 0;
	// 	let j = 1;

	// 	const dynamicLoop = setInterval(() => {
	// 		const dynamicWordIndex = i % DYNAMIC_WORD_KEYS.length;
	// 		const currentWord = t(DYNAMIC_WORD_KEYS[dynamicWordIndex]);

	// 		dynamicText.current.innerHTML = currentWord.substring(0, j);

	// 		if (j < currentWord.length + EOW_BUFFER) {
	// 			j++;
	// 		} else {
	// 			i++;
	// 			j = 1;
	// 		}
	// 	}, DYNAMIC_LETTER_TIMER);

	// 	return () => {
	// 		clearInterval(dynamicLoop);
	// 	};
	// }, [t]);

	return (
		<section id="home-splash-container">
			<div>
				<div className="title-wrapper semibold">
					{/* <span className="bold">{t('building-the-worlds')}</span>
					<span className="bold">{t('most-intelligent')}</span>
					<span className="bold">
						<span ref={dynamicText} className="dynamic-text bold" />
						&nbsp;
						{t('app')}
					</span> */}
					<span className="bold">{t('leader')}</span>
					<span className="bold">{t('automotive-software')}</span>
					<span className="bold dynamic-text">{t('connected-vehicles')}</span>
					
					{/* <DownloadButton>{t('download-driver-app')}</DownloadButton> */}

					<div className="tag-wrapper">
						<strong className="yellow black">{t('available-aaos')}</strong>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Splash;
